import axios from 'axios';
import { encrypt, decrypt } from 'helpers/rsa';

const useRSA = process.env.REACT_APP_RSA_URL?.split(', ');

export const httpV2 = axios.create({
  timeout: 60000,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

export const http = httpV2;

httpV2.interceptors.request.use(
  async (request) => {
    if (localStorage.getItem('tokenV2') !== null) request.headers.Authorization = `${localStorage.getItem('tokenV2')}`;
    return await request;
  },
  (error) => Promise.reject(error),
);

httpV2.interceptors.response.use(
  async (response) =>
    // if (
    //   useRSA.includes(response.config.url.replace(URL_V2, '/'))
    //   && process.env.REACT_APP_RSA_ENCYRPITION === 'enable'
    // ) {
    //   response.data.data = await decrypt(response.data.data);
    // }
    await response,
  (error) => {
    if (error.response) {
      const { data } = error.response;
      if (data.status === 401) {
        if (data.message === 'Unauthorized') {
          localStorage.clear();
          localStorage.removeItem('token');
          localStorage.removeItem('tokenV2');
          localStorage.removeItem('phase');
          localStorage.removeItem('persist:root');
          localStorage.removeItem('persist:root');
          localStorage.removeItem('persist:auth');
          localStorage.removeItem('persist:authV2');
          localStorage.removeItem('persist:matrix');
          // window.location.pathname = "/";
          return Promise.reject({
            message: 'Token expired. Please try login again.',
          });
        }
        return Promise.reject({
          message: 'Login failed. Please check your email and password!',
        });
      }
      window.newrelic.noticeError(error, {
        url: window.location.href,
        user: window.localStorage.name,
        impact: 'Fetching data failed ❌',
      });
      const message = data.message || error.message;
      return Promise.reject({ message, raw: data });
    } if (error.request) {
      window.newrelic.noticeError(error, {
        url: window.location.href,
        user: window.localStorage.name,
        impact: 'Fetching data failed ❌',
      });
      return Promise.reject({
        message:
          'There is problem connecting to server. Please check your connection!',
      });
    }
    window.newrelic.noticeError(error, {
      url: window.location.href,
      user: window.localStorage.name,
      impact: 'Fetching data failed ❌',
    });
    return Promise.reject({ message: error.message });
  },
);

export default httpV2;
